/**
 * Zhvendos nje markues te Leaflet-it butesisht, ne vend qe ta kerceje.
 *
 * Autobusi dergon pozicion te ri cdo disa sekonda. Me `setLatLng()` markuesi
 * zhduket nga nje pike dhe shfaqet ne tjetren, gje qe duket si kercim edhe pse
 * autobusi ka levizur normalisht. Ketu kalimi ndahet ne korniza, keshtu qe
 * levizja duket e vazhdueshme.
 *
 * Nuk eshte shpikje pozicionesh: markuesi ndjek saktesisht vijen midis dy
 * pikave reale, thjesht me vone se sa mberrin e dyta.
 */

/** Mbi kete distance nuk animohet: eshte korrigjim, jo levizje. */
const MAX_METRA = 2000;

/** Nen kete distance nuk ia vlen: dridhje e GPS-it ne vend. */
const MIN_METRA = 0.5;

/** Kufijte e kohezgjatjes, qe nje pauze e gjate te mos japi levizje te plogesht. */
const MIN_MS = 600;
const MAX_MS = 6000;

/** Sa zgjat kalimi kur ende nuk dime ritmin e pozicioneve. */
const MS_FILLESTAR = 2600;

const animacionet = new WeakMap();
const ritmi = new WeakMap();

function metra(a, b) {
  const R = 6371000;
  const dLat = ((b.lat - a.lat) * Math.PI) / 180;
  const dLng = ((b.lng - a.lng) * Math.PI) / 180;
  const la1 = (a.lat * Math.PI) / 180;
  const la2 = (b.lat * Math.PI) / 180;

  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(la1) * Math.cos(la2) * Math.sin(dLng / 2) ** 2;

  return R * 2 * Math.asin(Math.min(1, Math.sqrt(h)));
}

/**
 * Sa duhet te zgjase kalimi.
 *
 * Aq sa zgjati pritja e pozicionit te fundit: keshtu animacioni mbaron
 * pikerisht kur mberrin pika tjeter, dhe segmentet lidhen pa pauze. Nje
 * kohezgjatje fikse e le markuesin ose te ndalur ose te nderprere ne mes.
 */
function kohezgjatja(marker, tani) {
  const iFundit = ritmi.get(marker);
  ritmi.set(marker, tani);

  if (!iFundit) return MS_FILLESTAR;
  return Math.min(MAX_MS, Math.max(MIN_MS, tani - iFundit));
}

/**
 * @param {object} marker  markuesi i Leaflet-it (`mapObject`)
 * @param {Array}  destinacioni  [lat, lng]
 */
export function glideTo(marker, destinacioni) {
  if (!marker || !Array.isArray(destinacioni)) return;

  const [lat, lng] = destinacioni.map(Number);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;

  const nga = marker.getLatLng?.();
  const te = { lat, lng };

  // Nje animacion i mepareshem per te njejtin markues nderpritet: perndryshe
  // te dy do te luftonin per pozicionin.
  const iMepareshem = animacionet.get(marker);
  if (iMepareshem) cancelAnimationFrame(iMepareshem);

  if (!nga) {
    marker.setLatLng(te);
    return;
  }

  const d = metra(nga, te);
  if (d < MIN_METRA) return;
  if (d > MAX_METRA || typeof requestAnimationFrame !== 'function') {
    marker.setLatLng(te);
    return;
  }

  const fillimi = performance.now();
  const zgjat = kohezgjatja(marker, fillimi);
  const lat0 = nga.lat;
  const lng0 = nga.lng;

  const hap = (tani) => {
    // Shpejtesi e njetrajtshme, pa ngadalesim ne skaje. Butesia ne fillim e
    // fund duket e bukur per nje levizje te vetme, por kur segmentet vijne
    // njeri pas tjetrit ajo prodhon nje ndal-nis cdo disa sekonda — pikerisht
    // kercimi qe donim te hiqnim.
    const k = Math.min(1, (tani - fillimi) / zgjat);

    marker.setLatLng({
      lat: lat0 + (te.lat - lat0) * k,
      lng: lng0 + (te.lng - lng0) * k,
    });

    if (k < 1) {
      animacionet.set(marker, requestAnimationFrame(hap));
    } else {
      animacionet.delete(marker);
    }
  };

  animacionet.set(marker, requestAnimationFrame(hap));
}

export default { glideTo };
